import type { Mapping } from '@atlaskit/editor-prosemirror/transform';

import type { AgentEditChromeState } from './types';

export const mapAgentEditChromeState = (
	state: AgentEditChromeState,
	mapping: Mapping,
): AgentEditChromeState => {
	if (!state.ranges.length) {
		return state;
	}

	return {
		...state,
		ranges: state.ranges
			.map(({ from, to }) => ({
				from: mapping.map(from, -1),
				to: mapping.map(to, 1),
			}))
			.filter(({ from, to }) => from < to),
	};
};
